// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__DS0RX","site-title":"Navbar_site-title__o72-e"};